import { useSyncExternalStore } from 'react';
import { matchesStackedLayout, subscribeToStackedLayout } from '@/utils/stackedLayout';

export function useIsStackedLayout(): boolean {
  return useSyncExternalStore(subscribeToStackedLayout, matchesStackedLayout);
}
